import {BaseObject} from './BaseObject';
import {Contract} from './Contract';
import {User} from './User';
import SignaturePad from "signature_pad";

export class Transport extends BaseObject {
    id: number;
    type: string; // 'in', 'out'
    transportFrom: any = new Date();
    transportTo: any = new Date();
    contract: Contract | null = null;
    users: User[];
    note: string;
    isCatering: boolean = false;
    isKitchen: boolean = false;
    isExternal: boolean = false;
    outsidePrague: boolean = false;
    isManipulation: boolean = false;
    address: string;
    addressLat: number;
    addressLon: number;
    repeatTransportId: any;
    completeDatetime: any = null;
    completePerson: string = null;
    completeAmount: number = null;
    completeSign: any = null;
    completeUserId: User = null;
    rrule: any = null;
}




// WEBPACK FOOTER //
// /app/src/model/Entities/Transport.ts